module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "contact__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "contact__layout-card"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "top__layout-title"
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                If you have any doubt, suggestion or you have identified any data that you believe is missing or require curation, please let us know ["), _c('a', {
    attrs: {
      "href": "mailto:chemprobes@icr.ac.uk"
    }
  }, [_vm._v("chemprobes@icr.ac.uk")]), _vm._v("] to help us improve this resource for\n                the community.\n              ")]), _vm._v(" "), _c('v-divider')], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-360c8701"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrbContact.vue
// module id = 556
// module chunks = 1